// Human names for an opening rule's calendar values, shared by the dropdowns that
// offer them and the one-line summary that describes a rule. One vocabulary, so a
// rule's summary cannot name a day differently from the select the operator picked
// it in.

/** Month name in the operator's locale. A fixed non-leap year, so no date rolls over. */
export const monthName = (month: number): string => new Date(2001, month - 1, 1).toLocaleString(undefined, { month: 'long' });

/** ISO-8601 order: 1 = Monday … 7 = Sunday. */
const DAY_NAMES = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export const dayOfWeekName = (day: number): string => DAY_NAMES[day - 1] ?? String(day);

/** 1–5, where 5 is the last week of the month. */
const WEEK_OF_MONTH_NAMES = ['first', 'second', 'third', 'fourth', 'last'];

export const weekOfMonthName = (week: number): string => WEEK_OF_MONTH_NAMES[week - 1] ?? String(week);

const ORDINAL_WORDS = [
  'First',
  'Second',
  'Third',
  'Fourth',
  'Fifth',
  'Sixth',
  'Seventh',
  'Eighth',
  'Ninth',
  'Tenth',
  'Eleventh',
  'Twelfth',
  'Thirteenth',
  'Fourteenth',
  'Fifteenth',
  'Sixteenth',
  'Seventeenth',
  'Eighteenth',
  'Nineteenth',
  'Twentieth',
  'Twenty-first',
  'Twenty-second',
  'Twenty-third',
  'Twenty-fourth',
  'Twenty-fifth',
  'Twenty-sixth',
  'Twenty-seventh',
  'Twenty-eighth',
  'Twenty-ninth',
  'Thirtieth',
  'Thirty-first',
];

/** "First", "Second", … — how a dropdown spells a position out. */
export const ordinalWord = (n: number): string => ORDINAL_WORDS[n - 1] ?? String(n);

export const ordinalSuffix = (n: number): string => {
  const teens = n % 100;
  if (teens >= 11 && teens <= 13) return 'th';
  switch (n % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};

/**
 * A day of the month under the backend's sign convention: positive counts from the
 * start, `0` is the last day, negative counts back from the end. Phrased compactly
 * ("3rd", "last", "2nd from last") for use inside a sentence.
 */
export const nthOfMonthName = (nth: number): string => {
  if (nth === 0) return 'last';
  if (nth > 0) return `${nth}${ordinalSuffix(nth)}`;
  const back = Math.abs(nth);
  return `${back}${ordinalSuffix(back)} from last`;
};
